import { BaseSite, BaseStore, CmsComponent, Country, Language } from '@spartacus/core'

export interface EbBaseSite extends BaseSite {
  languages?: Language[]
  country?: EbCountry
  enableGoogleTracking?: boolean
}

export interface EbBaseStore extends BaseStore {
  downForMaintenance?: boolean
}

export interface EbCountry extends Country {
  localizedNames: any
}

export enum EbSiteContextType {
  COUNTRY = 'COUNTRY',
  LANGUAGE = 'LANGUAGE',
  CURRENCY = 'CURRENCY'
}

export interface EbSiteContextSelectorComponentData {
  entries?: string
}

export interface EbCountryCmsInterface extends CmsComponent {
  countryEntries?: string
}

export enum EbSiteContextFallbackValues {
  COUNTRY = 'DE',
  LANGUAGE = 'en',
  BASESITE = 'ebB2B-DEU'
}
